
// Storage utility functions for shared functionality

// Debug/logging helper with timestamp
export const logStorage = (prefix: string, message: string, data?: any) => {
  const timestamp = new Date().toISOString().slice(11, 19);
  console.log(`[${timestamp}][${prefix}] ${message}`, data || '');
};

// Helper function to check if localStorage is available
export const isLocalStorageAvailable = (): boolean => {
  try {
    const testKey = '__storage_test__';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn('localStorage is not available. Storage operations will be in-memory only.', e);
    return false;
  }
};
